import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu,
	KValidatableInput
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KSalesOrdersTable",

	mixins: [
		Crudable,
		KValidatableInput
	],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no sales orders to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching sales orders found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "salesOrderNumber"
		},

		value: {
			type: Array,
			default: () => []
		}
	},

	data: () => ( {
		crud: "sales_orders"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "SO #",
					value: "salesOrderNumber"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteSalesOrder( salesOrder ) {
			const deleteIndex = this.items.findIndex( item => salesOrder.id === item.id );

			return salesOrder.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		},

		genValidatableField( props ) {
			return <KDataTable
				attrs={this.$props}
				hasErrors={Boolean( props.errors.length )}
				headers={this.$_headers}
				on={{ ...this.$listeners }}
				scopedSlots={{
					"header.data-table-select": () => "Select",

					"item.actions": ( { item } ) =>
						<KDataTableMenu>
							<VList>
								<VListItem to={{
									name: "salesSalesOrder",
									params: { idSalesOrder: item.id }
								}}>
									<VListItemAction>
										<VIcon>visibility</VIcon>
									</VListItemAction>

									<VListItemContent>
										<VListItemTitle>View</VListItemTitle>
									</VListItemContent>
								</VListItem>

								{this.canDelete && <KActionDialog
									confirmButtonColor="error"
									confirmButtonText="Delete"
									loading={this.$wait.is( "delete sales order" )}
									onConfirm={() => this.deleteSalesOrder( item )}
									scopedSlots={{
										activator: ( { on } ) =>
											<VListItem on={on}>
												<VListItemAction>
													<VIcon>delete</VIcon>
												</VListItemAction>

												<VListItemContent>
													<VListItemTitle>Delete</VListItemTitle>
												</VListItemContent>
											</VListItem>
									}}
									title="Delete Sales Order"
								>
									Are you sure you want to delete the sales order <strong>{item.salesOrderNumber}</strong>?
								</KActionDialog>}
							</VList>
						</KDataTableMenu>,

					...this.$scopedSlots
				}}
				vModel={this.internalValue}
			></KDataTable>;
		}
	},

	render() {
		if ( this.showSelect ) {
			this.genValidationProvider();
		}

		return this.genValidatableField( { errors: [] } );
	}
} );
